<template>
  <div class="container container-fluid">
    <div class="">
      <div class="row">
        <!-- LESIONADOS? -->
        <div v-if="isFieldVisible('wondeds')" class="col-md-3 mt-3">
          <label for="wondeds" class="form-label text-left">Hubo heridos</label>
          <SelectTrueFalse
            class="form-control select-custom"
            :wondeds="formData.wondeds === 1"
            v-bind:data="selectedInsuredWodeds" 
            v-on:update:data="selectedInsuredWodeds = $event"
            @change="emitFieldChanged('wondeds')"
            required="required"
          ></SelectTrueFalse>
        </div>
        <!-- TIPO DE LESION -->
        <div v-if="selectedInsuredWodeds === true" class="col-md-2 mt-3">
          <label for="wonded_type" class="form-label text-left">{{ getFieldDescription('wonded_type') }}</label>
          <SelectWondedsTypes
            :wonded_type="formData.wonded_type"
            :selectedWodedsType="selectedWodedsTypes"
            @update:selectedWodedsType="selectedWodedsTypes = $event"
            @change="emitFieldChanged('wonded_type')"
            required="required"
          ></SelectWondedsTypes>


        </div>
      </div>
      <div v-if="isFieldVisible('wondeds_info')">
        <div v-for="(customField, index) in customFields" :key="index">
          <div class="row">
            <div class="col-md-3 mt-3">
              <label :for="'wondeds' + index" class="form-label text-center">
                Persona Lesionada {{ index+1 }}
              </label>
            </div>
            <!-- NOMBRE Y APELLIDO -->
            <div v-if="selectedInsuredWodeds === true" class="col-md-3 mt-3">
              <label for="wonded_name" class="form-label text-left">Nombre y Apellido</label>
              <div class="input-group bordered">
                <input
                  type="text"
                  class="form-control"
                  :name="'wonded_name' + index"
                  :id="'wonded_name' + index"
                  v-model="customField.wonded_name"
                  required="required"
                  maxlength="191"
                />
              </div>
            </div>
            <!-- DNI -->
            <div v-if="selectedInsuredWodeds === true" class="col-md-3 mt-3">
              <label for="wonded_dni" class="form-label text-left">DNI</label>
              <div class="input-group bordered">
                <input
                  type="number"
                  class="form-control"
                  :name="'wonded_dni' + index"
                  :id="'wonded_dni' + index"
                  v-model="customField.wonded_dni"
                  required="required"
                  maxlength="191"
                />
              </div>
            </div>
             <!-- TEL -->
             <div v-if="selectedInsuredWodeds === true" class="col-md-3 mt-3">
              <label for="wonded_phone" class="form-label text-left">Teléfono</label>
              <div class="input-group bordered">
                <input
                  type="text"
                  class="form-control"
                  :name="'wonded_phone' + index"
                  :id="'wonded_phone' + index"
                  v-model="customField.wonded_phone"
                  required="required"
                  maxlength="191"
                />
              </div>
            </div>
            
          </div>
          <!-- RELATO DEL HECHO-->
          <div v-if="selectedInsuredWodeds === true" class=" mt-3">
            <div class="col-md-12">
              <label for="wonded_phone" class="form-label text-left">Relato del hecho</label>
              <textarea
                class="form-control" 
                :name="'wonded_observations' + index"
                :id="'wonded_observations' + index"
                v-model="customField.wonded_observations"
                required="required"
                maxlength="1024"
              ></textarea>
            </div>
           </div>
        </div>
        <div @click="addCustomField" v-if="selectedInsuredWodeds === true" 
          class="btn btn-secondary mt-3">
          Agregar Persona
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import SelectTrueFalse from './selectDatos/SelectTrueFalse';
import SelectWondedsTypes from './selectDatos/SelectWondedsTypes';

export default {
  name: 'FormWonded',
  props: {
    data: Object,
  },
  components: {
    SelectTrueFalse,
    SelectWondedsTypes,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const dataFormsField = ref(props.data.dataFormsField);
    const selectedInsuredWodeds = ref(false);
    const selectedWodedsTypes = ref(null);

    const customFields = ref([]);

    const formData = ref({
      wondeds: null,
      wonded_type: null,
    });

    const isFieldVisible = (fieldName) => {
      return dataCompany.value && dataCompany.value[fieldName] === 1;
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);
 
      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;
 
        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    const emitFieldChanged = () => {
      const driverFields = ['wonded_type', 'wonded_name', 'wonded_dni', 'wonded_phone', 'wonded_observations'];
      const newFormData = { ...formData.value };
      
      if (selectedInsuredWodeds.value === false) {
        driverFields.forEach(field => {
          newFormData[field] = null;
        });
      } else {
        newFormData.wondeds = 1;
      }
      newFormData.wonded_type = selectedWodedsTypes.value;
      const customFieldsData = {
        wonded_name: customFields.value.map((field) => field.wonded_name),
        wonded_dni: customFields.value.map((field) => field.wonded_dni),
        wonded_phone: customFields.value.map((field) => field.wonded_phone),
        wonded_observations: customFields.value.map((field) => field.wonded_observations),
      };
      
      emit('formDataChanged', { ...newFormData, ...customFieldsData });
    };

    const addCustomField = () => {
      customFields.value.push({ wonded_name: '', wonded_dni: '', wonded_phone: '', wonded_observations: '' });
      emitFieldChanged();
    };

    onMounted(() => {
      selectedWodedsTypes.value = formData.value.wonded_type;
    });

    watch(selectedWodedsTypes, (newValue) => {
      if (newValue) { emitFieldChanged() } 
    });

    watch(customFields, () => {
      emitFieldChanged();
    }, { deep: true });

    return {
      dataCompany,
      isFieldVisible,
      getFieldDescription,
      dataFormsField,
      formData,
      emitFieldChanged,
      addCustomField,
      customFields,
      selectedInsuredWodeds,
      selectedWodedsTypes
    };
  },
};
</script>

 
